import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/port/app/homepage/components/Footer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/port/styles/index.css");
